var __jsx = React.createElement;
import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'next-i18next';
import AvailabilityYears from '@spa/shared/components/Unisystem/AvailabilityYears';
import { Wrapper } from './styles';
var Availability = function Availability(_ref) {
  var accommodationOffer = _ref.accommodationOffer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return __jsx(Wrapper, {
    id: "Availability"
  }, __jsx("h2", null, t('Availability')), __jsx(AvailabilityYears, {
    accommodationOffer: accommodationOffer
  }));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var accommodationOffer = _ref2.offer.offerAggregate.accommodation_offer;
  return {
    accommodationOffer: accommodationOffer
  };
};
export default connect(mapStateToProps)(Availability);